import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Tooltip from '@mui/material/Tooltip';
import { t } from '../i18n/translations';
import { SummaryTimePicker, TimeSelect, FieldSubtitle } from './Picker.styles';

const TOOLTIP_KEYS = {
    boats:    'boatTooltip',
    coaches:  'coachTooltip',
    riders:   'ridersTooltip',
    beginners: 'beginnersTooltip',
};

/**
 * Reusable labelled select for boats / coaches / riders / beginners.
 *
 * @param {object} props
 * @param {string}   props.arrayName  - field name used in handleChange (e.g. "boats")
 * @param {Array}    props.items      - options array; each item is either a {id, name} object or a plain value
 * @param {*}        props.value      - controlled value
 * @param {string}   props.label      - visible label text
 * @param {function} props.onChange   - change handler (receives the synthetic event)
 * @param {string}   props.lang       - active language ("ua" | "en")
 * @param {string}   [props.status]   - optional status string ("Getting coaches", "No coaches", "Getting boats")
 */
export default function SelectForm({ arrayName, items, value, label, onChange, lang, status }) {
    const tooltipKey = TOOLTIP_KEYS[arrayName];
    const hasTooltip = Boolean(tooltipKey);
    const labelWithTooltip = hasTooltip ? `${label} (*)` : label;
    const tooltipTitle = hasTooltip ? t(lang, tooltipKey) : '';

    const isEndLabel = label === 'Кінець' || label === 'End';
    const isDisabled = isEndLabel || status === 'No coaches' || status === 'Getting boats';

    return (
        <SummaryTimePicker variant="outlined" width={isEndLabel ? '35%' : '100%'}>
            {hasTooltip ? (
                <Tooltip
                    title={tooltipTitle}
                    interactive="true"
                    enterTouchDelay={0}
                    leaveTouchDelay={5000}
                >
                    <InputLabel id={`label-${arrayName}`}>{labelWithTooltip}</InputLabel>
                </Tooltip>
            ) : (
                <InputLabel id={`label-${arrayName}`}>{label}</InputLabel>
            )}

            <TimeSelect
                value={value}
                label={labelWithTooltip}
                onChange={onChange}
                name={arrayName}
                disabled={isDisabled}
            >
                {items.map((item, index) =>
                    item && typeof item === 'object' && item.name
                        ? <MenuItem value={item.id} key={index}>{item.name}</MenuItem>
                        : <MenuItem value={item} key={index}>{item}</MenuItem>
                )}
            </TimeSelect>

            {status?.length > 0 && (
                <FieldSubtitle variant="subtitle2" gutterBottom>
                    {status === 'Getting coaches' && t(lang, 'gettingCoaches')}
                    {status === 'No coaches'      && t(lang, 'noCoachesAvailable')}
                    {status === 'Getting boats'   && t(lang, 'gettingBoats')}
                </FieldSubtitle>
            )}
        </SummaryTimePicker>
    );
}
